import VStack from './VStack';
import React from 'react';
import {View, TouchableOpacity, StyleSheet} from 'react-native';
import {useSelector} from 'react-redux';
import {RootStore} from '../redux/store';
import {colorSwatches} from '../styles';
import Text from '../components/Text';
import LoadingSpinner from './LoadingSpinner';

const HeaderButton = props => {
  const loadingApprovals = useSelector((state: RootStore) => state.approvals.loading);
  const pendingOwnerApprovals = useSelector(
    (state: RootStore) => state.approvals.approvals,
  )?.filter(approval => approval.residentApprovalStatus === 'Pending');

  const pendingManagementApprovals = useSelector(
    (state: RootStore) => state.approvals.approvals,
  )?.filter(approval => approval.managementApprovalStatus === 'Pending');

  const newNotifs = useSelector((state: RootStore) => state.alerts.unread) || 0;

  const pendingOwnerCount = pendingOwnerApprovals?.length || 0;
  const pendingMgmtCount = pendingManagementApprovals?.length || 0;
  const isActive = props.activeTab === props.text;

  return (
    <TouchableOpacity
      style={[styles.tabWrapper, isActive && styles.activeTabWrapper]}
      onPress={() => props.setActiveTab(props.text)}>
      <VStack style={styles.tabStack}>
        <Text style={styles.tabTitle}>{props.text}</Text>

        {props.text === 'Pending approvals' && (
          <>
            {loadingApprovals ? (
              <View style={styles.tabLoading}>
                <LoadingSpinner size="small" color="white" />
              </View>
            ) : (
              <View style={styles.metaRow}>
                {/* Unit count */}
                <View style={styles.countPill}>
                  <Text style={styles.countText}>{pendingOwnerCount}</Text>
                </View>
                <Text style={styles.metaLabel}>Unit</Text>
                <Text style={styles.dot}>·</Text>
                {/* Management count */}
                <View style={styles.countPill}>
                  <Text style={styles.countText}>{pendingMgmtCount}</Text>
                </View>
                <Text style={styles.metaLabel}>Mgmt</Text>
              </View>
            )}
          </>
        )}

        {props.text === 'Notifications' && (
          <View style={styles.metaRow}>
            <View style={[styles.countPill, !newNotifs && styles.countPillMuted]}>
              <Text style={styles.countText}>{newNotifs}</Text>
            </View>
            <Text style={styles.metaLabel}>{newNotifs === 1 ? 'Unread' : 'Unread'}</Text>
          </View>
        )}
      </VStack>
    </TouchableOpacity>
  );
};

const HeaderTabs = ({activeTab, setActiveTab}) => {
  return (
    <View style={styles.container}>
      <View style={styles.tabsRow}>
        <HeaderButton
          text="Notifications"
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
        <HeaderButton
          text="Pending approvals"
          activeTab={activeTab}
          setActiveTab={setActiveTab}
        />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: colorSwatches.primary.color,
    paddingHorizontal: 8,
    width: '100%',
  },
  tabsRow: {
    flexDirection: 'row',
    gap: 8,
    width: '100%',
  },
  tabWrapper: {
    flex: 1,
    minHeight: 80,
    paddingHorizontal: 10,
    paddingTop: 8,
    paddingBottom: 12,
    borderBottomColor: colorSwatches.white.color,
    borderBottomWidth: 0,
    opacity: 0.88,
  },
  activeTabWrapper: {
    borderBottomWidth: 4,
    opacity: 1,
  },
  tabStack: {
    flex: 1,
  },
  tabTitle: {
    color: colorSwatches.white.color,
    fontSize: 14,
    fontWeight: '700',
  },
  metaRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 5,
    gap: 4,
  },
  countPill: {
    backgroundColor: 'rgba(255,255,255,0.25)',
    borderRadius: 4,
    minWidth: 20,
    paddingHorizontal: 5,
    paddingVertical: 1,
    alignItems: 'center',
  },
  countPillMuted: {
    backgroundColor: 'rgba(255,255,255,0.12)',
  },
  countText: {
    color: '#ffffff',
    fontSize: 11,
    fontWeight: '700',
  },
  metaLabel: {
    color: 'rgba(255,255,255,0.80)',
    fontSize: 11,
  },
  dot: {
    color: 'rgba(255,255,255,0.45)',
    fontSize: 13,
    marginHorizontal: 2,
  },
  tabLoading: {
    height: 28,
    justifyContent: 'center',
  },
});

export default HeaderTabs;
